const actorTypes = (intl) => {
  return [
    { 
      label: intl.formatMessage({ id: 'upload_flow_actor_type_all' }), 
      value: 'ALL'
    },
    { 
      label: intl.formatMessage({ id: 'upload_flow_actor_type_exhibitor' }), 
      value: 'EXHIBITOR'
    },
    { 
      label: intl.formatMessage({ id: 'upload_flow_actor_type_co_exhibitor' }), 
      value: 'CO_EXHIBITOR'
    },
    { 
      label: intl.formatMessage({ id: 'upload_flow_actor_type_agent_owned_exhibitor' }), 
      value: 'AGENT_OWNED_EXHIBITOR'
    },
    { 
      label: intl.formatMessage({ id: 'upload_flow_actor_type_agent' }), 
      value: 'AGENT'
    },
  ];
};

const boothRequirementTypes = (intl) => {
  return [
    {
      label: intl.formatMessage({ id: 'upload_flow_booth_requirement_both' }),
      value: 'BOTH'
    },
    {
      label: intl.formatMessage({ id: 'upload_flow_booth_requirement_yes' }),
      value: 'YES'
    },
    {
      label: intl.formatMessage({ id: 'upload_flow_booth_requirement_no' }),
      value: 'NO'
    },
  ];
};

export { actorTypes, boothRequirementTypes };
